"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Super simple class to allow many listeners for a single event
class EventListenerPool {
    constructor() {
        this.pool = [];
    }
    listen(handler) {
        this.pool.push(handler);
    }
    emit(payload) {
        for (const listener of this.pool) {
            listener(payload);
        }
    }
}
exports.default = EventListenerPool;
